module.exports = __webpack_public_path__ + "static/media/businesswoman.0c4415cc.png";